import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import {
  widgetCardStyle,
  labelStyle,
  footerStyle,
} from '../styles/widgetStyles'

function AskRiqCtaWidget() {
  const [hover, setHover] = useState(false)
  const navigate = useNavigate()

  return (
    <div
      style={{
        ...widgetCardStyle(hover, true),
        justifyContent: 'space-between',
        padding: '1.5rem',
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* NEW WRAPPING DIV */}
      <div style={{ width: '100%', maxWidth: '260px', textAlign: 'center' }}>
        <div style={{ ...labelStyle, fontSize: '1rem' }}>
          💬 Ask Riq, Our Coverage Assistant
        </div>

        <div
          style={{
            fontSize: '0.875rem',
            color: '#4b5563',
            margin: '0.5rem 0 1rem',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
          }}
        >
          Have a coverage question?  
          Riq gives fast, accurate answers based on real plan data.
        </div>

        <button
          onClick={() => navigate('/chat')}
          style={{
            fontSize: '0.8rem',
            padding: '0.4rem 0.75rem',
            border: 'none',
            borderRadius: '5px',
            backgroundColor: '#3b82f6',
            color: '#fff',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
          }}
        >
          Ask a Question →
        </button>

        <div style={footerStyle}>Riq is available 24/7</div>
      </div>
    </div>
  )
}

export default AskRiqCtaWidget
